<template>
  <div class="invalid-page">
    <h1>Ongeldige link</h1>
    <p>De pagina die je zoekt bestaat niet.</p>
    <router-link to="/">Terug naar startpagina</router-link>
  </div>
</template>

<script>
export default {
  name: "Invalid",
};
</script>

<style scoped>
.invalid-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 1rem;
  text-align: center;
}

h1 {
  font-size: 2rem;
  margin: 0;
  color: var(--text-primary);
}

p {
  color: var(--text-secondary);
  margin: 0;
}

a {
  color: var(--primary_color);
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  border: 1px solid var(--primary_color);
  border-radius: 4px;
  transition: all 0.2s;
}

a:hover {
  background: var(--primary_color);
  color: #000;
}
</style>
